import type { ReactNode } from 'react'

import { BoxSizeStep } from 'routes/Signup/Steps/BoxSize/BoxSizeStep'
import { DeliveryStep } from 'routes/Signup/Steps/Delivery/DeliveryStep'
import { PostcodeStep } from 'routes/Signup/Steps/Postcode/PostcodeStep'
import { SignupMotivationsStep } from 'routes/Signup/Steps/SignupMotivations/SignupMotivationsStep'
import { SignupSteps } from 'routes/Signup/constants/SignupSteps'

/**
 * SignupSteps to StepComponent relation.
 */
export const AVAILABLE_STEP_COMPONENTS: {
  [step in SignupSteps]: ReactNode
} = {
  [SignupSteps.SIGNUP_MOTIVATIONS]: SignupMotivationsStep,
  [SignupSteps.BOX_SIZE]: BoxSizeStep,
  [SignupSteps.POSTCODE]: PostcodeStep,
  [SignupSteps.DELIVERY]: DeliveryStep,
}
